import React, { Fragment, useState, useEffect } from "react";
import { ReactSession } from "react-client-session";
import { Link, useHistory, useLocation } from "react-router-dom";
import {
  Typography,
  TextField,
  Select,
  InputLabel,
  MenuItem,
  Button,
  Box,
  Grid,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import Breadcrumb from "../Breadcrumb";
//theme
import Theme, { useStyles } from "../Theme.js";
const CreateUser2 = () => {
  const location = useLocation();
  const [login, setLogin] = useState("");
  const [mdp, setMdp] = useState("");
  const [retour, setRetour] = useState("");
  const classes = useStyles();
  const [value, setValue] = useState("");
  const history = useHistory();

  /**
   * @async
   * @function fetchLogin
   * @return {void}
   */
  useEffect(() => {
    console.log(location.state);
  }, []);

  async function fetchInsertOnservation(user_id, theme, id_observation) {
    try {
      console.log(user_id, theme, id_observation);
      const tabuserobservation = {
        id_observation: id_observation,
        theme: theme,
        id_user: user_id,
      };
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(tabuserobservation),
      };
      const response = await fetch(
        window.location.protocol +
          "//" +
          window.location.hostname +
          "/natturapi/users/observation",
        requestOptions
      );
      if (response.status === 200) {
        setRetour("Obervation créée");
      } else {
        setRetour("Problème lors de la création");
      }
    } catch (err) {
      console.log(err);
    }
  }
  async function fetchCreateUser() {
    try {
      let formData = new FormData(document.querySelector("#creationcompte"));
      let mdp1 = document.querySelector("#mdp1").value;
      let mdp2 = document.querySelector("#mdp2").value;
      // let mailinfo = document.querySelector("#mailinfo").checked;
      let email = document.querySelector("#email").value;
      const tabuser = {
        mailinfo: 0,
        login: email,
        user_type: location.state.user_type,
      };
      for (var pair of formData.entries()) {
        if (pair[0] !== "mdp2") {
          let colname = pair[0];
          tabuser[colname] = pair[1];
          //const count = tabuser.push({ [colname]: pair[1] });
        }
      }
      if (mdp1 === mdp2) {
        tabuser["secteur_activite"] = "";
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(tabuser),
        };
        const response = await fetch(
          window.location.protocol +
            "//" +
            window.location.hostname +
            "/natturapi/users",
          requestOptions
        );
        const user_id = await response.json();
        if (response.status === 201) {
          fetchInsertOnservation(
            user_id,
            location.state.theme,
            location.state.id_observation
          );
          if (location.state.id_observation) {
            alert(
              "Vous avez créé votre compte, vous allez être redirigé à l'accueil pour effectuer une nouvelle observation."
            );
            ReactSession.set("login", email);
            ReactSession.set("user_id", user_id);
            setRetour("Utilisateur créé");

            history.push("/");
          }
        } else {
          alert(
            "Problème lors de la création du compte vous êtes peut être deja inscrit"
          );
        }
      } else {
        alert("Vos mot de passe doivent être identiques");
      }
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <Fragment>
      <style>{".suivantprecedent{display:none;}"}</style>
      <Breadcrumb size={8} current={0} />
      <Box className={classes.subHeader}>
        <Typography variant="h3" className={classes.subHeaderTitle}>
          Créer un compte
        </Typography>
        <Typography variant="body1" style={{ fontSize: 12 }}>
          Vos informations {retour}
        </Typography>
      </Box>
      <Grid
        container
        style={{ maxWidth: "100%", paddingLeft: "30px", paddingRight: "30px" }}
      >
        <form
          noValidate
          autoComplete="off"
          style={{ width: "100%" }}
          id="creationcompte"
        >
          <TextField
            label="Nom"
            name="nom"
            style={{ width: "100%" }}
            onChange={(event) => setLogin(event.target.value)}
            required
          />
          <TextField
            label="Prénom"
            name="prenom"
            style={{ width: "100%" }}
            onChange={(event) => setLogin(event.target.value)}
            required
          />
          <InputLabel id="age-label" style={{ marginTop: 18 }}>
            Pays
          </InputLabel>
          <Select
            labelId="age-label"
            id="pays"
            name="pays"
            style={{ width: "100%" }}
            required
            label="Pays"
            value={"FR"}
          >
            <MenuItem value={"FR"}>France</MenuItem>
            <MenuItem value={"ES"}>Espagne</MenuItem>
          </Select>
          <TextField
            label="Code Postal"
            name="cp"
            style={{ width: "100%" }}
            onChange={(event) => setLogin(event.target.value)}
            required
          />
          <TextField
            label="Ville"
            name="ville"
            style={{ width: "100%" }}
            onChange={(event) => setLogin(event.target.value)}
            required
          />
          <TextField
            label="Téléphone"
            name="telephone"
            style={{ width: "100%" }}
            onChange={(event) => setLogin(event.target.value)}
            required
          />
          <TextField
            label="Email"
            name="email"
            id="email"
            type="email"
            style={{ width: "100%" }}
            onChange={(event) => setLogin(event.target.value)}
            required
          />
          {/*
          <TextField
            label="Secteur d'activité"
            name="secteur_activite"
            style={{ width: "100%" }}
            onChange={(event) => setLogin(event.target.value)}
            required
          />
  */}
          <TextField
            label="Date d’anniversaire"
            type="date"
            name="date_anniversaire"
            style={{ width: "100%" }}
            onChange={(event) => setLogin(event.target.value)}
            required
          />
          <TextField
            label="mot de passe"
            name="mdp"
            id="mdp1"
            style={{ width: "100%" }}
            onChange={(event) => setMdp(event.target.value)}
            required
            type="password"
          />
          <TextField
            label="Confirmation Mot de Passe"
            name="mdp2"
            id="mdp2"
            style={{ width: "100%" }}
            onChange={(event) => setMdp(event.target.value)}
            required
            type="password"
          />
          <FormControlLabel
            name="mailinfo"
            id="mailinfo"
            control={<Checkbox />}
            label="J'accepte de recevoir des emails d'informations"
          />
          <FormControlLabel
            name="rgpd"
            style={{ alignItems: "start" }}
            required
            id="rgpd"
            control={<Checkbox />}
            label={
              <p style={{ fontSize: 10, fontWeight: "normal" }}>
                J’accepte que les informations recueillies sur ce formulaire
                soient enregistrées dans un fichier informatisé par le Conseil
                Départemental de l’Ariège. Elles sont conservées pendant 2 ans à
                compter de votre dernière activité. Elles sont destinées au
                Service Nattur. Les informations recueillies ne seront ni
                transmises à des tiers ni vendues sauf demande explicite de
                votre part. Conformément à la loi « informatique et libertés »
                du 6 janvier 1978, vous pouvez exercer votre droit d'accès, de
                rectification, de suppression des données vous concernant. Pour
                cela merci de contacter le Conseil Départemental de l’Ariège à
                l'adresse contact@nattur.eu ou par courrier à l'adresse suivante
                : Hôtel du Département 5-7 rue du Cap de la Ville 09001 FOIX
                Cedex
              </p>
            }
          />
          <Button
            onClick={() => fetchCreateUser()}
            variant="contained"
            color="primary"
            className={classes.navButton2}
            style={{
              marginTop: 20,
              fontSize: 15,
              BackgroundColor: "#e50039",
              fontWeight: "bold",
            }}
          >
            Créer le compte
          </Button>
          <br />
          <br />
        </form>
      </Grid>
    </Fragment>
  );
};

export default CreateUser2;
